import React, { FC } from 'react';

type LogTimeStampProps = {
  timestamp?: number;
};

export const LogTimeStamp: FC<LogTimeStampProps> = ({ timestamp }) => {
  const date = new Date(0);
  date.setUTCSeconds(timestamp || 1000);

  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return (
    <span>
      {formattedDate}, {formattedTime}
    </span>
  );
};
